import { AuditTrailEntryResponse } from "@/services/conciliation-audit";
import { ColumnDef } from "@tanstack/react-table";

import { AUDIT_LABELS, AUTOMATIC_ACTOR_EMAIL } from "../messages";

const actorOf = (entry: AuditTrailEntryResponse): string =>
  entry.changed_by === AUTOMATIC_ACTOR_EMAIL
    ? AUDIT_LABELS.AUTOMATIC_ACTOR
    : entry.changed_by;

export const auditColumns: ColumnDef<AuditTrailEntryResponse>[] = [
  {
    accessorKey: "changed_at",
    header: AUDIT_LABELS.COLUMN_WHEN,
    cell: ({ row }) => (
      <span className="whitespace-nowrap text-sm text-gray-700">
        {new Date(row.original.changed_at).toLocaleString("pt-BR")}
      </span>
    ),
  },
  {
    accessorKey: "changed_by",
    header: AUDIT_LABELS.COLUMN_WHO,
    cell: ({ row }) => (
      <span className="text-sm text-gray-900">{actorOf(row.original)}</span>
    ),
  },
  {
    accessorKey: "description",
    header: AUDIT_LABELS.COLUMN_WHAT,
    cell: ({ row }) => (
      <span className="text-sm text-gray-700">{row.original.description}</span>
    ),
  },
  {
    accessorKey: "ip",
    header: AUDIT_LABELS.COLUMN_ORIGIN,
    cell: ({ row }) => (
      <span className="text-sm text-gray-500">
        {row.original.ip ?? AUDIT_LABELS.NO_IP}
      </span>
    ),
  },
];
